import dayjs from "dayjs"
import PropTypes from "prop-types"
import React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"

import AppButton from "../AppButton"
import StyledAppHeading from "../Typography/Heading"

// ----------------------------------------------------------------------------

function EventCard(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const {
        title,
        summary,
        days,
        price,
        locations,
        url,
        bookingsOpen,
        onClick,
        id,
    } = props

    const duration = days ? `${days[0].startTime} - ${days[0].endTime}` : null
    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function renderPrice() {
        return price ? `${price}€` : "L'evento è completamente gratuito"
    }

    function renderDate() {
        if (days?.length === 1) {
            return dayjs(days[0]?.date).format("DD MMMM YYYY")
        } else {
            const firstDay = days?.[0]
            const lastDay = days?.[days?.length - 1]
            return `Dal ${dayjs(firstDay?.date).format(
                "DD MMMM YYYY"
            )} al ${dayjs(lastDay?.date).format("DD MMMM YYYY")}`
        }
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    const message = bookingsOpen ? (
        <div className="bookings">Prenotazioni aperte</div>
    ) : (
        <div className="bookings error">Prenotazioni chiuse</div>
    )

    return (
        <div className={props.className}>
            <div className="title" dangerouslySetInnerHTML={{ __html: title }}>
                {/* {renderTitleParts()} */}
            </div>
            <div className="image-section">
                <div className="image-bar"></div>
                <div className="image">
                    <img src={url} alt="sample"></img>
                    {message}
                </div>
                <div className="image-bar content-bar">
                    <div className="info">
                        <div className="bar-time">{renderDate()}</div>
                        <div className="bar-location">
                            {locations?.length === 1 ? (
                                <>
                                    <span className="city">
                                        {locations[0].city}
                                    </span>
                                    <span className="province">
                                        ({locations[0].province})
                                    </span>
                                </>
                            ) : (
                                <span className="location-summary">
                                    <span style={{ opacity: 0 }}>hello</span>
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="text-section">
                <div className="upper">
                    <StyledAppHeading className="time">
                        {renderDate()}, {duration}
                    </StyledAppHeading>

                    <div
                        className="description"
                        dangerouslySetInnerHTML={{ __html: summary }}
                    ></div>
                </div>
                <div className="lower">
                    <div className="price">{renderPrice()}</div>
                    <Link
                        onClick={(e) => {
                            e.preventDefault()
                            onClick?.()
                        }}
                        className="book-btn-wrapper"
                        to={`/events/${id}`}
                    >
                        <AppButton
                            className="book-btn"
                            uxType="primary"
                            htmlType="button"
                        >
                            Prenota il tuo appuntamento
                        </AppButton>
                    </Link>
                </div>
            </div>
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

EventCard.propTypes = {
    className: PropTypes.string.isRequired,
    title: PropTypes.string,
    summary: PropTypes.string,
    days: PropTypes.array,
    price: PropTypes.number,
    city: PropTypes.string,
    province: PropTypes.string,
    id: PropTypes.any,
    url: PropTypes.string,
    bookingsOpen: PropTypes.bool,
    onClick: PropTypes.func,
}

EventCard.defaultProps = {}

// ----------------------------------------------------------------------------

const StyledEventCard = styled(EventCard)`
    & {
        border-radius: 24px;
        width: 100%;
        height: 470px;
        overflow: hidden;
        position: relative;
        display: flex;
        flex-direction: column;
        box-shadow: 0px 4px 35px ${({ theme }) => theme.colors.shadowColor};
        .title {
            position: absolute;
            width: 100%;
            top: 15px;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .title-part,
            p {
                display: block;
                text-align: center;
                background-color: ${({ theme }) => theme.colors.white};
                font-family: "Poppins-Bold";
                font-size: 28px;
                line-height: 32px;
                margin-bottom: 4px;
                padding: 3px 10px;
            }
        }
        .image-section {
            .bookings {
                position: absolute;
                background-color: ${({ theme }) => theme.colors.white};
                padding-left: 20px;
                padding-right: 20px;
                transform: translateY(-50%);
                line-height: 100%;
                height: 20px;
                display: flex;
                align-items: center;
                font-family: "Poppins-Bold";

                &.error {
                    color: ${({ theme }) => theme?.colors?.errorColor};
                }
            }
            .image-bar {
                width: 100%;
                height: 40px;
                background-color: ${({ theme }) =>
                    theme.colors.backgroundPrimary};
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: center;

                &.content-bar {
                    height: 50px;
                    .info {
                        color: ${({ theme }) => theme.colors.white};
                        margin-top: 10px;
                        padding-left: 20px;

                        .bar-time {
                            font-family: "Poppins-Bold";
                            font-size: 12px;
                            line-height: 100%;
                        }
                        .bar-location {
                            line-height: 150%;
                            .city {
                                font-size: 18px;
                                font-family: "Poppins-Bold";
                            }
                            .province {
                                margin-left: 5px;
                                font-size: 14px;
                            }
                            .location-summary {
                                font-size: 18px;
                                font-family: "Poppins-Bold";
                            }
                        }
                    }
                }
            }
            .image {
                height: 120px;
                width: 100%;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
        }
        .text-section {
            padding: 30px;
            display: flex;
            flex-grow: 1;
            flex-direction: column;
            justify-content: space-between;
            .upper {
                .time {
                    font-family: "Poppins-Bold";
                    font-size: 16px;
                    margin-bottom: 10px;
                    line-height: 100%;
                }
                .description {
                    font-family: "Poppins-Regular";
                    font-size: 13px;
                    line-height: 150%;
                    color: ${({ theme }) => theme.colors.textMuted};
                }
            }
            .lower {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                button,
                .price {
                    height: 50px;
                }
                .price {
                    font-family: "Poppins-Bold";
                    font-size: 16px;
                    display: flex;
                    align-items: center;
                }
                button {
                    width: 190px;
                    margin-left: 10px;
                    text-align: center;
                    padding: 0;
                    line-height: 100%;
                }
            }
        }
        @media (max-width: 575px) {
            .text-section {
                padding: 30px 20px;
                .lower {
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;

                    .price {
                        align-self: flex-end;
                        text-align: right;
                        font-size: 15px;
                        line-height: 1.1;
                    }
                    .book-btn-wrapper {
                        display: block;
                        width: 100%;
                        margin-top: 5px;
                        .book-btn {
                            width: 100%;
                            height: 35px;
                            font-size: 12px;
                            margin: 0;
                            padding: 0;
                            display: block;
                            max-width: unset;
                        }
                    }
                }
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default StyledEventCard
